export class FraudDisclosure {
    StateProvince: string;
    title: string;
    text: string;
}
